export default "__VITE_ASSET__4a227847__"